<sales-final-message-top-up-loan *ngIf="isTopUpLoan"/>
<app-sales-final-message-general (nextStepEvent)="onNextStep()" *ngIf="!isTopUpLoan && !isKredicash"/>
<app-sales-final-message-kredicash [message]="message" (nextStepEvent)="onNextStep()" (gotoStepEvent)="gotoStepEvent.emit($event)" *ngIf="!isTopUpLoan && isKredicash"/>
